<jupiter-panel-container>
  <jupiter-panel-header
    header
    [panelDef]="panelDef"
    [editMode]="editMode | async"
    (startEditLayout)="onStartEditLayout()"
    (cancelEditLayout)="onCancelEditLayout()"
    (saveLayout)="onSaveLayout()"
  >
    <ng-container customActions> </ng-container>
    <ng-container editModeCustomActions> </ng-container>
  </jupiter-panel-header>
  <ng-container body>
    @if (model?.id) {
      <comment-view
        [relatedToId]="model.id"
        [relatedToType]="relatedTo.startsWith('co_') ? 'CustomObjects::Value' : relatedTo"
        [account]="account"
      ></comment-view>
    }
  </ng-container>
</jupiter-panel-container>
